/**
 * Curriculum Vitae Item Detail Formatter.
 */
window.curriculumVitaeItemDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
